import { AnyAction } from 'redux'

interface ViewModeState {
  mode: string | false
}

const noViewMode: ViewModeState = {
  mode: false
}

const viewMode = (state = noViewMode, action: AnyAction) => {
  switch (action.type) {
    case 'SET_VIEW_MODE':
      const newState = {
        mode: action.mode,
      }

      return {
        ...state,
        ...newState,
      }

    default:
      return state
  }
}

export default viewMode
